// ============================================================================
// permissions.js — quem é "Master" (acesso total, inclui Configurações)
// ============================================================================
// Master = admin com poder total. Os outros admins (criados via UI) têm acesso
// total ao app MENOS a aba Configurações (que mexe em coisas críticas: limpar
// dados, secrets, integrações, etc).
//
// Critério: email exato na MASTER_EMAILS. Só esses emails são master.
// ============================================================================

const MASTER_EMAILS = new Set([
  'marcelo.barbeariamoema@gmail.com',
]);

export function isMasterUser(user) {
  if (!user?.email) return false;
  return MASTER_EMAILS.has(String(user.email).trim().toLowerCase());
}
